export default __webpack_public_path__ + "static/media/Background_dev.2e248336.png";